import * as constants from '../helpers/constants/dataTypeConstants';

import type { DateSelectionState, Direction } from './types';

export const getDateSelectionSelectedDate = (
  state: DateSelectionState,
  direction: Direction,
) => {
  if (direction === constants.OUTBOUND_DIRECTION) return state.selectedOutbound;
  if (direction === constants.INBOUND_DIRECTION) return state.selectedInbound;
  throw new Error(`Invalid element: ${direction}`);
};

export const getDateSelectionSelectedMonth = (
  state: DateSelectionState,
  direction: Direction,
) => {
  if (direction === constants.OUTBOUND_DIRECTION)
    return state.outboundMonthDate;
  if (direction === constants.INBOUND_DIRECTION) return state.inboundMonthDate;
  throw new Error(`Invalid element: ${direction}`);
};

export const getDateSelectionMinCalendarDate = (
  state: DateSelectionState,
  direction: Direction,
) => {
  if (direction === constants.INBOUND_DIRECTION) return state.minInboundDate;
  if (direction === constants.OUTBOUND_DIRECTION) return state.minOutboundDate;
  throw new Error(`Invalid element: ${direction}`);
};

export const getDateSelectionMinDate = (state: DateSelectionState) =>
  state.minDate;
export const getDateSelectionMaxDate = (state: DateSelectionState) =>
  state.maxDate;
export const getDateSelectionSelectedOutboundDate = (
  state: DateSelectionState,
) => state.selectedOutbound;
export const getDateSelectionSelectedInboundDate = (
  state: DateSelectionState,
) => state.selectedInbound;
export const getDateSelectionSelectedOutboundMonth = (
  state: DateSelectionState,
) => state.outboundMonthDate;
export const getDateSelectionSelectedInboundMonth = (
  state: DateSelectionState,
) => state.inboundMonthDate;
export const isDateSelectionWholeYearSelected = (state: DateSelectionState) =>
  state.wholeYear;
export const isDateSelectionReturn = (state: DateSelectionState) =>
  state.isReturn;

export const hasDateSelectionHotelDataOnBothDates = (
  state: DateSelectionState,
) => state.hasHotelDataOnBothDates;

export const getDateSelectionTripDuration = (state: DateSelectionState) =>
  state.tripDuration;

export const getDateSelectionCheapestCombinations = (
  state: DateSelectionState,
) => state.cheapestCombinations;
